"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHUITheme = CHUITheme;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CHUITheme(darkMode, textSize) {
  return {
    palette: _objectSpread({
      mode: darkMode ? 'dark' : 'light'
    }, darkMode === false ? {
      primary: {
        main: '#10274c'
      },
      secondary: {
        main: "#f5752f"
      }
    } : {
      primary: {
        main: '#0072CE'
      },
      secondary: {
        main: "#f5752f"
      }
    }),
    typography: {
      fontSize: textSize === 'Regular' ? 14 : textSize === 'Medium' ? 17 : textSize === 'Large' ? 20 : 14,
      fontFamily: "Arial,sans-serif"
    }
  };
}